"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shift = exports.PopoverContentWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Popover = __importStar(require("@radix-ui/react-popover"));
const useCellTheme_1 = require("./useCellTheme");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const TooltipIcon_1 = require("../../../../molecules/TooltipIcon");
const translate_1 = require("../../../../translate");
const ShiftCrossSection_1 = require("../../ShiftCrossSection");
const useSchedule_1 = require("../useSchedule");
const RelativeWrapper = (0, styled_1.default)(elements_1.Div)(({ fullHeight }) => ({
    position: 'relative',
    width: '100%',
    height: fullHeight ? '100%' : 'auto',
}));
const ShiftBadge = (0, styled_1.default)(elements_1.Div)(({ background }) => ({
    background,
    borderRadius: constants_1.theme.border.radius.normal,
    position: 'absolute',
    top: `-${constants_1.theme.border.width.thin}px`,
    right: `-${constants_1.theme.border.width.thin}px`,
    fontWeight: constants_1.theme.font.weight.book,
    padding: `${constants_1.theme.spacing['0.5']}px ${constants_1.theme.spacing['1.5']}px`,
    lineHeight: 1,
}));
const Cell = (0, styled_1.default)(elements_1.Div)(({ background, hoverBackground, border, hoverable, disabled, opacity, selected, isUrgent, zoom, fullHeight, }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
    width: '100%',
    position: 'relative',
    padding: `${constants_1.theme.spacing[1.5]}px ${constants_1.theme.spacing[2]}px`,
    background,
    opacity,
    border: border ?? `1px solid ${background}`,
    borderRadius: constants_1.theme.border.radius.normal,
    textAlign: 'start',
    ...(disabled && { cursor: 'not-allowed' }),
    ...(isUrgent && {
        border: `1px solid ${constants_1.Color.RED}`,
        borderLeft: zoom !== 'month' ? `19px solid ${constants_1.Color.RED}` : undefined,
    }),
    ...(fullHeight && {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    '.checkbox': {
        display: selected ? 'block' : 'none',
    },
    ...(hoverable
        ? {
            cursor: 'pointer',
            ':hover': {
                filter: 'brightness(0.95)',
                ...(hoverBackground && { background: hoverBackground }),
                '.checkbox': {
                    display: 'block',
                },
            },
        }
        : {
            ':hover': {
                '.checkbox': {
                    display: 'block',
                },
            },
        }),
}));
exports.PopoverContentWrapper = (0, styled_1.default)(Popover.Content)({
    zIndex: constants_1.theme.zIndex.popover,
});
const Shift = ({ title, interestedCandidates = 0, shiftIds, startTime, endTime, status, isAcknowledged, onDelete, popoverContent: PopoverContent, tooltip, disabled = false, unselectable, error, isUrgent, onClick, onCallBadge, onCallShift, stretch, }) => {
    const t = (0, translate_1.useTranslations)();
    const { zoom } = (0, useSchedule_1.useSchedule)();
    const { isSelected, toggleSelected, enableSelectShifts } = (0, useSchedule_1.useSelectedShifts)(shiftIds);
    const { background, hoverBackground, border, label, color, subtitleOpacity, opacity, icon, badgeColor, iconProps, } = (0, useCellTheme_1.useCellTheme)()[status];
    const fullHeight = zoom === 'month' && !!stretch;
    const countBadge = shiftIds.length > 1 ? ((0, jsx_runtime_1.jsx)(ShiftBadge, { background: constants_1.Color.LIGHTER_BLUE, children: (0, jsx_runtime_1.jsxs)(elements_1.Text, { display: "block", color: constants_1.Color.BLUE, fontSize: constants_1.theme.font.size['6.5'], children: ["\u00D7", shiftIds.length] }) })) : null;
    const interestedBadge = ((0, jsx_runtime_1.jsx)(ShiftBadge, { background: constants_1.Color.BLUE, children: (0, jsx_runtime_1.jsxs)(elements_1.Text, { bold: true, color: constants_1.Color.WHITE, display: "block", fontSize: constants_1.theme.font.size['6.5'], letterSpacing: '-2px', children: [interestedCandidates, " / ", shiftIds.length] }) }));
    const deleteBadge = ((0, jsx_runtime_1.jsx)(ShiftBadge, { background: constants_1.Color.TRANSPARENT, children: (0, jsx_runtime_1.jsx)(elements_1.Clickable, { onClick: onDelete, styles: { py: 0.5 }, children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { size: "sm", name: "TrashIcon", color: constants_1.Color.MEDIUM_RED }) }) }));
    // TODO: refactor this to show on hover/selected and add "can select" prop
    const selectBadge = (
    // styling here could benefit from other approaches, but that might require larger changes
    (0, jsx_runtime_1.jsx)(ShiftBadge, { className: "checkbox", styles: { display: 'table' }, onClick: (e) => {
            // so we do not open the popover
            e.stopPropagation();
        }, background: constants_1.Color.TRANSPARENT, children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { styles: { marginTop: 3 }, size: "sm", checked: isSelected, onChange: toggleSelected }) }));
    const labelNode = ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { fontSize: constants_1.theme.font.size['6.5'], color: color, bold: true, display: "block", children: title ?? label }), isAcknowledged && ((0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, { color: constants_1.Color.WHITE, size: "sm", iconName: "EyeIcon", text: t.ui.shift_acknowledged_by_candidate(), backgroundColor: constants_1.Color.TRANSPARENT }))] }));
    const urgentLabel = ((0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, { size: "sm", styles: {
            position: 'absolute',
            left: -17,
            top: 14,
        }, color: constants_1.Color.LIGHTER_RED, backgroundColor: constants_1.Color.TRANSPARENT, design: "solid", iconName: "ExclamationIcon", tooltipIntent: "warning", text: t.shifts.urgent() }));
    const clickable = !!onClick || !!PopoverContent;
    const cellContent = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [icon ? ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, children: [labelNode, (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: icon, size: "sm", color: color, design: "solid" })] })) : (labelNode), (0, jsx_runtime_1.jsxs)(elements_1.Text, { mt: 0.5, fontSize: constants_1.theme.font.size['6.5'], color: color, opacity: subtitleOpacity, display: "block", styles: { letterSpacing: '-0.5px' }, children: [startTime, " \u2013 ", endTime, onCallBadge && ((0, jsx_runtime_1.jsx)(elements_1.Badge, { squared: true, size: "xxs", color: badgeColor, styles: { ml: 1 }, children: t.$onCallTypeAbbreviation(onCallBadge.type) }))] }), onCallShift && (0, jsx_runtime_1.jsx)(ShiftCrossSection_1.ShiftCrossSection, { size: "sm", ...onCallShift }), interestedCandidates ? interestedBadge : countBadge, onDelete && deleteBadge, !unselectable && enableSelectShifts && selectBadge, isUrgent && urgentLabel] }));
    const cell = ((0, jsx_runtime_1.jsx)(Cell, { disabled: disabled, as: clickable ? 'button' : 'div', background: background, hoverBackground: hoverBackground, onClick: onClick ? () => onClick(shiftIds) : undefined, border: border, opacity: opacity, selected: isSelected, hoverable: !!clickable, isUrgent: isUrgent, zoom: zoom, fullHeight: fullHeight, children: zoom !== 'month' ? (cellContent) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: iconProps.name, design: "solid", color: color }), interestedCandidates ? interestedBadge : countBadge] })) }));
    const withTooltip = tooltip ? ((0, jsx_runtime_1.jsxs)(RelativeWrapper, { fullHeight: fullHeight, children: [tooltip && ((0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, { text: tooltip.message, tooltipIntent: tooltip.intent, styles: {
                    zIndex: constants_1.theme.zIndex.tooltip,
                    position: 'absolute',
                    top: -constants_1.theme.spacing[2],
                    right: -constants_1.theme.spacing[2],
                } })), cell] })) : error ? ((0, jsx_runtime_1.jsxs)(RelativeWrapper, { fullHeight: fullHeight, children: [cell, error] })) : (cell);
    if (!PopoverContent)
        return withTooltip;
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, { children: [(0, jsx_runtime_1.jsx)(Popover.Trigger, { asChild: true, children: withTooltip }), (0, jsx_runtime_1.jsx)(exports.PopoverContentWrapper, { sideOffset: 4, align: "start", side: "right", onOpenAutoFocus: (event) => event.preventDefault(), children: (0, jsx_runtime_1.jsx)(PopoverContent, { shiftId: shiftIds }) })] }));
};
exports.Shift = Shift;
